import { STOCK_SELECTION_COMPLETED } from './types';

import { call, select, takeEvery } from 'redux-saga/effects';
import ProductUtils from 'helpers/ProductUtils';
import { productBundle } from 'apis/cloudcatalog';
import { trackLegacyEvent } from 'helpers/analytics';

export const productDetailSizingSelector = state => state.product.detail.sizing;
export const cloudcatalogSelector = state => state.environmentConfig.api.cloudcatalog;

export function* fireStockEvent({ colorId, productId, styleId, selectedSizing }) {
  const sizing = yield select(productDetailSizingSelector);
  let stock = ProductUtils.getStockBySize(sizing.stockData, colorId, selectedSizing);
  let inStock = true;

  if (!stock) {
    // looks like it's OOS, so call cloud catalog to get full list of
    // stocks so we can pass along stockId if such a stockId exists
    inStock = false;
    const cloudcatalog = yield select(cloudcatalogSelector);
    const response = yield call(productBundle, cloudcatalog, { productId, includeOos: true });
    if (response.status === 200) {
      const bundle = yield call([response, response.json]);
      stock = ProductUtils.getStockBySize(bundle.product[0].sizing.stockData, colorId, selectedSizing, true);
    }
  }

  const stockEventPayload = ProductUtils.getStockEventPayload(productId, styleId, colorId, sizing, selectedSizing, stock, inStock);
  yield call(trackLegacyEvent, 'StockEventHC', null, stockEventPayload);
}

export default function* sagas() {
  yield takeEvery(STOCK_SELECTION_COMPLETED, fireStockEvent);
}
